export default "__VITE_ASSET__1b255c01__"